// REST data source: image content moderation. Owns the endpoint and the transport
// so nothing above the platform layer issues this fetch directly.
export const MODERATION_URL_PATH = '/maa-planner-assistant/image-moderation';

/**
 * POST an image for content moderation.
 * @param {Object} args
 * @param {string} args.host - apionline host origin
 * @param {Blob|File} args.imageFile
 * @param {Object} args.context - upload context (serialized as JSON)
 * @returns {Promise<{imageId, isValid, storageLink, moderationStatus}>}
 */
export const moderateImage = ({ host, imageFile, context }) => {
  const moderationUrl = host + MODERATION_URL_PATH;
  const formData = new FormData();
  formData.append('imageFile', imageFile);
  formData.append('context', JSON.stringify(context));

  return fetch(moderationUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: formData,
    credentials: 'include',
  }).then((res) => {
    if (!res.ok) {
      throw new Error(`Moderation request failed with status ${res.status}`);
    }
    return res.json();
  }).then(({ imageId, isValid, storageLink, moderationStatus }) => ({
    imageId,
    isValid,
    storageLink,
    moderationStatus,
  }));
};
